import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { PreEvent, Info, Ticket } from '../../models';
import { environment } from '../../../../environments/environment'

@Injectable({
  providedIn: 'root'
})
export class EventsService {

  private apiUrl = environment.GANIEMSAPIEndpoint;

  private event_id = 1;
  private event_year = 2017;

  constructor(private http: HttpClient) { }

  public getEvents() {
    const headers = this.createRequestHeader();
    return this.http.get<PreEvent[]>(`${this.apiUrl}activities/event/1/year/2019`, { headers: headers });
  }

  public getInfos() {
    const headers = this.createRequestHeader();
    return this.http.get<Info[]>(`${this.apiUrl}infos/events/1`, { headers: headers });
  }

  public getTickets() {
    const headers = this.createRequestHeader();
    return this.http.get<Ticket[]>(`${this.apiUrl}tickets/events/1`, { headers: headers });
  }


  private createRequestHeader() {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    // tslint:disable-next-line:max-line-length
    headers.append('ganievent-access-token', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoiZ2FuaS1qd3QtcGF5bG9hZCIsImlhdCI6MTUyOTczOTc0Mn0.lz5JdisuguHwCnNWVFLGyqtf7kZt59bmDSQ1UNUWvVo');

    return headers;
  }
}
